import { render, staticRenderFns } from "./ClosedAccountingInfo.vue?vue&type=template&id=5084fb3d&"
import script from "./ClosedAccountingInfo.vue?vue&type=script&lang=js&"
export * from "./ClosedAccountingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports